$( document ).ready(function() {

  $('.box-input').on('keypress', function(key) {
    if(key.charCode < 48 || key.charCode > 57) return false;
  });
  
  $(".box-input").keyup(function(){
	var $stock = $(".box-select option:selected").attr('data-stockqty'),
        $this = $(this),
        $value =$this.val()
    
    if($this.hasClass('with-oe')){
      var $minusStock = 1;
    }else if($this.hasClass('no-buffer')){
      var $minusStock = 0;
    }else if($this.hasClass('with-fm')){
      var $minusStock = 1;
    }else{
      var $minusStock = 1;   
    }
    var $onlyStock = $stock - $minusStock;
    
//     else if($this.hasClass('no-buffer')){
//       var $minusStock = 0;
//     }
    
    if($value > parseInt($onlyStock)){
//       alert('no stock available')
//       $value =$this.val(1)
      var $modal = $('.prod-modal'),
          $loader = $('.div-loader'),
          $message = $('.out-of-stock-message');
      $modal.show();
      $message.show();
      setTimeout(function() {
        $modal.hide();
        $message.hide();
        $value =$this.val(1)
      }, 1000)
    } 
  });

  var vidLength = $('#vid_prod').length;
  if(vidLength != 0){
    $('vid_prod').play();
  }

  var myBtn1 = document.getElementById('wishlist-txt');
  $(".wishlist_btnCont").mouseover(function() {
    myBtn1.style.textDecorationLine = "underline";
  });

  $(".wishlist_btnCont").mouseout(function() {
    myBtn1.style.textDecorationLine = "none";
  });
  $('.btn_add_prod').click(function(e){
    var $this = $(this),
        $parent = $this.closest('.blackboard-container'),
        $variantId = $parent.find('.box-select option:selected').data('mainid'),
        $quantity = $parent.find('.data_input_product.qty').val(),
        $productData = "updates["+ $variantId+"]="+ $quantity+" ";

    if($this.hasClass('btn-cart-disabled')){
      e.preventDefault();
    }else{
//       jQuery.post('/cart/update.js', 
//                   "updates["+$variantId+"]="+$quantity+"",
//                   setTimeout(function(){location.reload();},2000));
      
      var $modal = $('.prod-modal'),
          $loader = $('.div-loader'),
          $message = $('.add-to-cart-message');

          $modal.show();
          $loader.show();
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: $quantity,
          id: $variantId
        },
        dataType: 'json',           
        success: function(product) {
          gtag("event", "add_to_cart", {
            currency: "PHP",
            items: [
              {
                item_id: product.product_id.toString(),
                item_name: product.product_title,
                currency: "PHP",
                item_brand: product.vendor,
                item_category: product.product_type,
                item_variant: product.variant_title,
                price: parseInt(product.price) / 100,
                quantity: product.quantity
              }
            ]
          });

          
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: 'addToCart',
            ecommerce: {
              currencyCode: "PHP",
              add: {
                products: [{
                  name: product.product_title,
                  id: product.product_id.toString(),
                  price: parseInt(product.price) / 100,
                  brand: product.vendor,
                  category: product.product_type,
                  variant: product.variant_title,
                  quantity: product.quantity
                 }]
              }
            }
          });
          $message.show();
          $modal.hide();
          $loader.hide();
          setTimeout(function(){
            $message.hide();
            location.reload();
          }, 3000)
        }
      }); 
      
    }
  })

  $('.box-select').on('change',function(){
    var $this = $(this),
        $parent = $this.closest('.blackboard-container'),
        stockQty1 = $("option:selected", this).attr('data-stockqty'),
        stockId = $("option:selected", this).data('mainid'),
        cartQty = $('#minicart-items').children('.mini-cart-products[data-incartid="'+stockId+'"]').data('incart'),
        alltags = $("option:selected", this).data('ptags'),
        prTags = $this.data('product-tags'),
        noBufferTags = ['Short-Shelf Life', 'Online Exclusives', 'Fast Moving', 'Vegan', 'Seasonal', 'Bath Bombs', 'Body', 'Christmas', 'Fragrances', 'Bath', 'Shower Gels', 'Body Scrub', 'Face', 'Perfume', 'Hair', 'New', 'Gifts'];
    
    var withBuffer = noBufferTags.map(tag => {
      if(prTags.includes(tag)) {
        return true
      }else {
        return false
      }
    })
    
    
    cartQty = (isNaN(cartQty) ? 0 : cartQty);
// `${$('.box-input').hasClass('no-buffer') ? parseInt(stockQty1) : 1}`
    $('.box-input').val(1);
    if(alltags.includes("Fast Moving")){
      var alltotal = stockQty1 - cartQty;
      if( alltotal <= 4 ){
        $parent.find('.btn_add_prod').addClass('btn-cart-disabled');
        $parent.find('.btn_add_prod span').text('OUT OF STOCK')
      }else{
        $parent.find('.btn_add_prod').removeClass('btn-cart-disabled');
        $parent.find('.btn_add_prod span').text('ADD TO CART')
      }
    }else if(alltags.includes("Online Exclusive")){
      var alltotal = stockQty1 - cartQty;
      if( alltotal <= 1 ){
        $parent.find('.btn_add_prod').addClass('btn-cart-disabled');
        $parent.find('.btn_add_prod span').text('OUT OF STOCK')
      }else{
        $parent.find('.btn_add_prod').removeClass('btn-cart-disabled');
        $parent.find('.btn_add_prod span').text('ADD TO CART')
      }
    }else{
      var alltotal = stockQty1 - cartQty,
          defBuffer = withBuffer.includes(true) ? 0 : 1;
      if( alltotal <= defBuffer ){
        $parent.find('.btn_add_prod').addClass('btn-cart-disabled');
        $parent.find('.btn_add_prod span').text('OUT OF STOCK')
      }else{
        $parent.find('.btn_add_prod').removeClass('btn-cart-disabled');
        $parent.find('.btn_add_prod span').text('ADD TO CART')
      }
    }
  });
  
  var vidLength = $('#vid_prod').length;
  if(vidLength != 0){
    var myVideo = document.getElementById('vid_prod');
    if (typeof myVideo.loop == 'boolean') { // loop supported
      myVideo.loop = true;
    } else { // loop property not supported
      myVideo.addEventListener('ended', function () {
        this.currentTime = 0;
        this.play();
      }, false);
    }
  }

});



